var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 72,
    viewBox: "0 0 63 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.5153 9.59165C50.5841 9.59165 42.8949 6.85885 36.7426 1.85356C33.7049 -0.617852 29.3497 -0.617852 26.3118 1.85356C20.1595 6.85885 12.4703 9.59165 4.53906 9.59165C2.06237 9.59165 0.0546875 11.5993 0.0546875 14.076V26.0946C0.0546875 41.5127 6.99741 56.1111 18.9574 65.8413L22.6487 68.8445C27.8202 73.0518 35.2345 73.0518 40.4058 68.8445L44.0971 65.8413C56.0571 56.1111 62.9997 41.512 62.9999 26.0938C62.9999 21.4795 62.9999 17.1434 62.9999 14.0748C62.9997 11.5982 60.992 9.59165 58.5153 9.59165Z",
    fill: "url(#paint0_linear_4077_32073)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9998 14.0749C62.9998 11.5982 60.9922 9.59161 58.5155 9.59161C50.5842 9.59161 42.8951 6.85881 36.7427 1.85352C35.2238 0.617891 33.3756 0 31.5273 0V72C34.6738 72 37.8202 70.9482 40.406 68.8445L44.0973 65.8413C56.0573 56.1111 62.9998 41.512 63 26.0938C62.9998 21.4796 62.9998 17.1435 62.9998 14.0749Z",
    fill: "url(#paint1_linear_4077_32073)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5269 68.0432C30.6622 68.0432 29.8167 67.7426 29.1459 67.197L22.0857 61.453C16.9289 57.2576 12.694 51.8666 9.83885 45.8631C6.98375 39.8596 5.47461 33.1723 5.47461 26.5245V16.9868C5.47461 15.8329 6.41792 14.8518 7.57009 14.7909C15.4275 14.3754 23.0237 11.4617 29.1458 6.4811C29.8167 5.93532 30.6622 5.63477 31.5267 5.63477C32.3914 5.63477 33.237 5.93516 33.9075 6.48095C40.0297 11.4618 47.6262 14.3755 55.4837 14.7909C56.6357 14.8518 57.5789 15.8328 57.5789 16.9865V26.5239C57.5789 33.1718 56.0697 39.8592 53.2146 45.8628C50.3595 51.8666 46.1246 57.2576 40.9678 61.453L33.9075 67.197C33.2371 67.7426 32.3916 68.0432 31.5269 68.0432Z",
    fill: "url(#paint2_linear_4077_32073)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0937 36.2562H24.9619V29.3213C24.9619 25.899 27.7364 23.1245 31.1587 23.1245H31.8969C35.3192 23.1245 38.0937 25.899 38.0937 29.3213V36.2562Z",
    fill: "url(#paint3_linear_4077_32073)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4056 44.9415L37.9758 23.5117V51.6401H20.959L39.101 69.7821C39.5484 69.4956 39.9849 69.1845 40.4051 68.8426L44.0965 65.8394C50.9887 60.2321 56.2144 53.0076 59.4056 44.9415Z",
    fill: "url(#paint4_linear_4077_32073)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5281 20.8584C26.4508 20.8584 22.3203 24.9891 22.3203 30.0663V42.3988H26.0701V30.0663C26.0701 27.0567 28.5185 24.6082 31.5281 24.6082C34.5376 24.6082 36.9861 27.0567 36.9861 30.0663V42.3988H40.7358V30.0663C40.7358 24.9891 36.6053 20.8584 31.5281 20.8584Z",
    fill: "url(#paint5_linear_4077_32073)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7776 33.2334H24.2785C21.4711 33.2334 19.1963 35.5082 19.1963 38.3156V47.8151C19.1963 50.6225 21.4711 52.8973 24.2785 52.8973H38.7776C41.585 52.8973 43.8599 50.6225 43.8599 47.8151V38.3156C43.8599 35.5084 41.585 33.2334 38.7776 33.2334Z",
    fill: "#D6A7C6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1963 42.0054V47.8143C19.1963 50.6217 21.4711 52.8965 24.2785 52.8965H38.7777C41.585 52.8965 43.8599 50.6217 43.8599 47.8143V42.0054H19.1963Z",
    fill: "url(#paint6_linear_4077_32073)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4026 44.9142V47.5741C33.4026 48.0916 33.1926 48.5615 32.8526 48.8989C32.5125 49.2389 32.0451 49.4489 31.5276 49.4489C30.4926 49.4489 29.6528 48.6089 29.6528 47.5741V44.9142C28.0653 44.1493 27.0129 42.4519 27.2204 40.5294C27.4353 38.5396 29.0428 36.9271 31.0326 36.7072C33.6475 36.4172 35.8598 38.4571 35.8598 41.0119C35.86 42.7318 34.855 44.2142 33.4026 44.9142Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4077_32073",
    x1: 5.15773,
    y1: 3.39906,
    x2: 59.4353,
    y2: 57.6767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4077_32073",
    x1: 42.9663,
    y1: 31.8209,
    x2: 18.723,
    y2: 41.9223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024C67",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2251,
    stopColor: "#0A4A63",
    stopOpacity: 0.225
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#204657",
    stopOpacity: 0.572
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9956,
    stopColor: "#433F44",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#433F43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4077_32073",
    x1: 66.9439,
    y1: 66.0491,
    x2: 18.9195,
    y2: 18.0248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024C67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4077_32073",
    x1: 37.153,
    y1: 34.7067,
    x2: 25.9595,
    y2: 27.5208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024C67",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2251,
    stopColor: "#0A4A63",
    stopOpacity: 0.225
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#204657",
    stopOpacity: 0.572
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9956,
    stopColor: "#433F44",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#433F43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4077_32073",
    x1: 50.6942,
    y1: 54.4506,
    x2: 29.0076,
    y2: 40.5283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024C67",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2251,
    stopColor: "#0A4A63",
    stopOpacity: 0.225
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572,
    stopColor: "#204657",
    stopOpacity: 0.572
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9956,
    stopColor: "#433F44",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#433F43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4077_32073",
    x1: 24.0223,
    y1: 26.8228,
    x2: 33.3281,
    y2: 36.1287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4077_32073",
    x1: 31.5281,
    y1: 42.0054,
    x2: 31.5281,
    y2: 52.8965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6A7C6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A86B93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.75b5b614db4aec877e725cd1219ef231.svg";
export { ForwardRef as ReactComponent };